import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const businessTripFormConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default businessTripFormConfig;
